module.exports = __webpack_public_path__ + "img/headPhoto.png";